module.exports = __webpack_public_path__ + "static/media/share-link-grey.92926e95.svg";